import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import DomainDropdown from "./domain-dropdown";

function mapStateToProps(state) {
  return {
    transactionRequest: state.transactionRequest,
    transactions: state.transactions,
    bids: state.bids,
    errorField: state.onSubmitDetails.errorFields,
    actionType: state.actionType,
    texts: state.translatedTexts,
    userDetails: state.userDetails,
    isSimulateMode: state.isSimulateMode,
    simulatedUserDetails: state.simulatedUserDetails
  };
}
function mapDispatchToProps(dispatch) {
  let actionDispatchers = bindActionCreators(actionCreators, dispatch);
  return actionDispatchers;
}

export default connect(mapStateToProps, mapDispatchToProps)(DomainDropdown);
